import { Injectable } from '@angular/core';
import { Topics } from '@common/interfaces/topics';
import { IID_RISORSE_CREATION } from '@common/interfaces/interfaceData';
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export type IIDRisorseCreationState = EntityState<IID_RISORSE_CREATION, ID>;

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_RISORSE_CREATION , realtimeEntity: 'IID_RisorseCreation'})
@InterfaceDataStore(InterfaceName.RISORSE_CREATION)
export class IIDRisorseCreationStore extends EntityStore<IIDRisorseCreationState> {
  constructor() {
    super([]);
  }
}
